import { IDealsValidation } from '../types/deals';
import { defaulLangTextValidation, defaultTTranslate, MEASURE } from 'src/constants/main';
import { IDeal } from 'src/types/combo';
import { DELIVERY_ORDER_TYPE, PRODUCT_TYPE } from 'src/types/product';

export const defaultDealValidation: IDealsValidation = {
  valid: true,
  images: true,
  name: defaulLangTextValidation,
  category: true,
  price: {
    state: true,
  },
  items: [],
  itemsLength: true,
  pricesBalance: true,
};

export const defaultDeal: IDeal = {
  id: 0,
  external_id: undefined,
  name: defaultTTranslate,
  order_type: DELIVERY_ORDER_TYPE.ALL,
  description: undefined,
  price: '',
  calories: null,
  weight: '',
  unit: MEASURE.NULL,
  //
  type: PRODUCT_TYPE.DEAL_COMBO,
  items: [],
  //
  image: '',
  images: undefined,
  //
  min_quantity: 1,
  is_donation: 0,
  is_favorite: 0,
  sort: 0,
  earn: undefined,
  redeem: undefined,
  //
  is_modifiers: 0,
  modifiers: [],
  //
  is_size: 0,
  size: null,
  sizes: [],
  //
  is_exclusions: 0,
  exclusions: [],
  //
  category: undefined,
  upsales_items: [],
  //
  out_of_stock: 0,
  status: 1,
  is_delete: 0,
  //
  is_draft: true,
  allergens: [],
  nutrients: null,
  nutrient: null,
};
